import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../menu.css';

function Menu() {
  const [shouldHide, setShouldHide] = React.useState(true);
  const location = useLocation();

  const subItemClasses = (path: string) => {
    if ("/" + path === location.pathname) {
      return "subItem subItemActive";
    } else {
      return shouldHide
        && (location.pathname !== "/collage"
          && location.pathname !== "/drawing"
          && location.pathname !== "/sculpture") ? "subItem hide" : "subItem";
    }
  };

  const topItemClasses = (path: string) => {
    if (location.pathname.startsWith("/" + path) ||
        ("/" === location.pathname && path === "work")) {
      return "topItem topItemActive";
    } else {
      return "topItem"
    }
  };

  const startHover = () => {
    setShouldHide(false);
  };

  const endHover = () => {
    setShouldHide(true);
  };

  return (
    <div className="menu">
      <div className="name"><Link to="/">MAHAL DE MAN</Link></div>
      <div className="menuItems">
        <div className="item"><Link to="/work" className={topItemClasses("work")}>WORK</Link></div>
        <div className="item"><Link to="/cv" className={topItemClasses("cv")}>CV</Link></div>
        <div className="item"><Link to="/statement" className={topItemClasses("statement")}>STATEMENT</Link></div>
        <div className="item"><Link to="/contact" className={topItemClasses("contact")}>CONTACT</Link></div>
      </div>
    </div>
  );
}

export default Menu;